module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "convert-wrapper"
  }, [_c('h1', [_vm._v("正在生成中，大概需要 " + _vm._s(_vm.estimatedTime.lowerEt) + " - " + _vm._s(_vm.estimatedTime.upperEt) + " 分钟，请稍候...")]), _vm._v(" "), _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('spinner', {
    staticClass: "spinner",
    attrs: {
      "size": 160,
      "text": _vm.$t(("project.state." + (_vm.project.state)))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "background-image img"
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('hint.project.convert.secondary')))]), _vm._v(" "), (!_vm.user.wechat_mp_connected && _vm.wxConnection.url && !_vm.tbcMode) ? _c('div', {
    staticClass: "qrcode wechat"
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: 'url(' + '//qrcode.ppj.io/' + _vm.wxConnection.url + ')'
    })
  }), _vm._v(" "), _c('p', {
    staticClass: "hint",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('qrcode.convert'))
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11596f5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/show/convert/index.vue
// module id = 897
// module chunks = 3